var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_222_35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1158 3.05176e-05H9.88423C4.42532 3.05176e-05 0 4.42535 0 9.88426V25.1158C0 30.5747 4.42532 35 9.88423 35H25.1158C30.5747 35 35 30.5747 35 25.1158V9.88426C35 4.42535 30.5747 3.05176e-05 25.1158 3.05176e-05Z",
    fill: "url(#paint0_linear_222_35)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4281 30.7844H10.5718C6.92914 30.7844 3.96387 27.8212 3.96387 24.1765V10.3222C3.96387 6.67956 6.92709 3.71429 10.5718 3.71429H24.4261C28.0687 3.71429 31.034 6.67751 31.034 10.3222V24.1765C31.034 27.8191 28.0707 30.7844 24.4261 30.7844H24.4281ZM10.5718 5.53152C7.92984 5.53152 5.78109 7.68026 5.78109 10.3222V24.1765C5.78109 26.8184 7.92984 28.9672 10.5718 28.9672H24.4261C27.068 28.9672 29.2167 26.8184 29.2167 24.1765V10.3222C29.2167 7.68026 27.068 5.53152 24.4261 5.53152H10.5718Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4988 24.7045C13.3876 24.7045 10.0437 21.3606 10.0437 17.2493C10.0437 13.1381 13.3876 9.79422 17.4988 9.79422C21.6101 9.79422 24.954 13.1381 24.954 17.2493C24.954 21.3606 21.6101 24.7045 17.4988 24.7045ZM17.4988 11.6094C14.3903 11.6094 11.8589 14.1388 11.8589 17.2493C11.8589 20.3599 14.3883 22.8893 17.4988 22.8893C20.6094 22.8893 23.1388 20.3599 23.1388 17.2493C23.1388 14.1388 20.6094 11.6094 17.4988 11.6094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.574 11.1715C26.364 11.1715 27.0045 10.531 27.0045 9.74101C27.0045 8.951 26.364 8.31056 25.574 8.31056C24.784 8.31056 24.1436 8.951 24.1436 9.74101C24.1436 10.531 24.784 11.1715 25.574 11.1715Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_222_35",
    x1: 0,
    y1: 17.5011,
    x2: 35,
    y2: 17.5011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD65B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#DC486A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#672FC8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_222_35"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramSocial);
export default __webpack_public_path__ + "static/media/instagram_social.ba936d7b4cedd36877a438fac11a2040.svg";
export { ForwardRef as ReactComponent };